export { default } from "./QuizOakImage";
